<template>
    <div class="main-content">
        <the-header :title="t('Epicrisis')" :buttons="headerButtons"/>
        <nav-body :links="nav">
            <data-grid ref="list"
                       :settings="grid"
                       :page="currentPage"
                       storeDispatchList="epicrisis/list"
                       v-on:button-delete="deleteItem($event.id)"
                       v-on:changePage="$emit('changePage', $event)"
            />
        </nav-body>
    </div>
</template>
<script>
    import TemplateList from '../../../../admin/Pages/Templates/List';
    import TheHeader from '../../../../admin/Layout/TheHeader'
    import NavBody from '../../../../admin/Layout/NavBody'
    import DataGrid from '../../../../core/DataGrid/DataGrid'
    import {admin} from '../Admin'

    export default {
        mixins: [
            admin
        ],
        components: {
            TheHeader,
            NavBody,
            TemplateList,
            DataGrid
        },
        watch: {
            '$route.params'(newValue, oldValue) {
                if (newValue.type !== oldValue.type) {
                    this.loading = true;
                    setTimeout(() => {
                        this.loading = false;
                    }, 50);
                }
            }
        },
        computed: {
            currentPage() {
                return parseInt(this.$route.params.page);
            },
        },
        methods: {
            deleteItem(id) {
                this.$store.dispatch('epicrisis/remove', id).then((response) => {
                    this.$refs.list.fetchData();
                });
            }
        },
        data() {
            return {
                loading: false,
                headerButtons: [
                    {
                        type: 'link',
                        to: () => {
                            return {name: 'epicrisisCreateNew'};
                        },
                        name: this.t('Create'),
                        icon: 'plus',
                        styleClass: 'btn-success',
                    }
                ],
                grid: {
                    buttons: [
                        {
                            type: 'link',
                            key: 'edit',
                            name: this.t('Edit'),
                            icon: 'eye',
                            styleClass: 'btn-primary btn-sm',
                            to: (item) => {
                                return {
                                    name: 'epicrisisEdit',
                                    params: {
                                        id: item.id
                                    }
                                };
                            }
                        }, {
                            type: 'action',
                            key: 'delete',
                            name: this.t('Delete'),
                            icon: 'trash-alt',
                            modalText: this.t('Do you want to delete template?'),
                            styleClass: 'btn-danger btn-sm'
                        }
                    ],
                    columns: [
                        {
                            type: 'string',
                            name: this.t('Name'),
                            key: 'name',
                            scrollable: true,
                            filter: {
                                type: 'fulltext',
                                likeType: '%_like_',
                            }
                        },
                    ]
                },
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/private/admin/epicrisis/List.vue